
import { defineComponent} from "vue";

export default defineComponent({
    name: "service-infor",
    setup(props, { emit }) {
        return {};
    },
});
